import { ReactNode } from 'react'

export interface Connector {
  title: string
  icon: ReactNode
  connectorId: ConnectorName
}

export enum ConnectorNameEnum {
  METAMASK = 'Metamask',
  TRUSTWALLET = 'TrustWallet',
  WALLETCONNECT = 'WalletConnect',
  METAMASK_WC = 'MetamaskWC'
}

export enum ConnectorName {
  Injected = 'injected',
  WalletConnect = 'walletconnect',
  MetamaskWC = 'metamask_wc'
}

export enum ConnectStep {
  CONNECT_WALLET,
  VERIFY_WALLET,
  VERIFIED_WALLET
}
